import IndustryDetailPage from "@/pages/industries/components/IndustryDetailPage";

export default function FintechPage() {
  return <IndustryDetailPage slug="fintech" />;
}